import script from "./purchaseReport.vue?vue&type=script&setup=true&lang=js"
export * from "./purchaseReport.vue?vue&type=script&setup=true&lang=js"

import "./purchaseReport.vue?vue&type=style&index=0&id=2d9f9575&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2d9f9575"]])

export default __exports__